import React from "react"
import { Redirect } from "react-router-dom"
import { useAuth } from "../../services/useAuth"
import { useMountEffect } from "../../utils"

const Logout = () => {
  const { logout } = useAuth()

  useMountEffect(() => {
    logout()
  })

  console.log("[Logout]", "Signing out")

  return <Redirect to="/login" />
}

export default Logout
